import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSplit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconSplit"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C12.4142 2 12.75 2.33579 12.75 2.75V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V2.75C11.25 2.33579 11.5858 2 12 2ZM2 4.75C2 4.33579 2.33579 4 2.75 4H9V20H2.75C2.33579 20 2 19.6642 2 19.25V4.75ZM15 4H21.25C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H15V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSplit;
